export class Counselling {
    counsellingId: number;
    counsellingTypeId: number;
    counsellingTypeName: string;
    counsellingNo: string;
    locationId: number;
    locationName: string;
    patientId: number;
    patientName: string;
    umrNo: string;
    patientGender: string;
    packageModuleId: number;
    packageName: string;
    packageTypeName: string;
    moduleTypeName: string;
    chargeCategoryId: number;
    chargeCategoryName: string;
    chargeModuleTemplateId: number;
    templateName: string;
    startDate: Date;
    endDate: Date;
    patientSignature: string;
    counsellorSignature: string;
    patientSignatureRootPath: string;
    counsellorSignatureRootPath: string;
    isInUse: boolean;
    payTypeId?: number;
    payTypeName?: string;
    insuranceCompanyId?: number;
    insuranceCompanyName?: string;
    tpaId?: number;
    tpaName?: string;
    patientOrganization?: string;
    totalQuantity: number;
    subTotal: number;
    packageDiscount: number;
    discountType: string;
    discountPercentage?: number;
    discountAmount?: number;
    discount: number;
    total: number;
    isDraft: boolean;
    active: boolean;
    createdBy: number;
    createdByRoleId: number;
    createdByName: string;
    createdDate: Date;
    modifiedBy?: number;
    modifiedDate?: Date;
    modifiedByName: string;
    isModifying: boolean;
    isDeleting: boolean;
    AdmissionNo: string;
    comments: string;
    consentFormsIds: string;
}

export interface ICounsellingPatientInfo {
    patientName: string;
    umrNo: string;
    patientGender: string;
}